import {Component, Input, OnChanges, OnInit, SimpleChanges, Inject} from '@angular/core';
import {BtxPerformanceListItem} from "@biletix/core/models/event/performance-list-item.model";
import {TranslateService} from "@ngx-translate/core";
import { APP_BASE_HREF } from "@angular/common";

@Component({
    standalone: false,
    selector: 'btx-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit, OnChanges {

    @Input() listItem!: BtxPerformanceListItem;

    @Input() region?: string;
    @Input() lang?: string;
    @Input() definitionCode?: string;
    @Input() parentEventFlexibleTime?: boolean;

    date: string | number | Date = new Date();

    timeFormat = "HH:mm"
    dayFormat = "d"
    monthFormat = "LLLL"

    statusText: string = '';

    constructor(private translateService: TranslateService,
                @Inject(APP_BASE_HREF) private baseHref: string) {

    }

    ngOnInit(): void {
        this.date = this.listItem.performanceDate as Date;
        this.statusText = this.translateService.instant(("performance.status." + this.listItem?.status));
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.date = this.listItem.performanceDate as Date;
    }

    performanceItemClasses() {
        return {
            'sold-out': !this.listItem.active
        }
    }

    generateHref(eventCode?: string, performanceCode?: string, region?: string, lang?: string, queryParams?:object): string {
    if (!eventCode || !region || !lang) {
        return '';
    }
    // Base URL
    let url = `${this.baseHref}performance/${eventCode}/${performanceCode}/${region}/${lang}`;

    if (queryParams && Object.keys(queryParams).length > 0) {
        const filteredParams = Object.entries(queryParams)
          .filter(([_, value]) => value !== undefined) // Sadece tanımlı değerleri tut
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {}); // Nesneye çevir

        if (Object.keys(filteredParams).length > 0) {
          const searchParams = new URLSearchParams(filteredParams as Record<string, string>);
          url += `?${searchParams.toString()}`;
        }
      }
    return url;
    }

    statusClasses() {
        return {
            success: this.listItem.status === "s01_onsale",
            'status-sold-out': this.listItem.status === "s02_soldout",
            'status-soon': this.listItem.status === "s03_soon",
            'status-canceled': this.listItem.status === "s04_canceled",
            'status-postponed': this.listItem.status === "s05_postponed",
            'status-boxoffice': this.listItem.status === "s06_boxoffice",
            'status-otherchannelwbox': this.listItem.status === "s15_other_channel_list_with_boxoffice",
            'status-checkback': this.listItem.status === "s12_check_back_later",
            'status-oldover': this.listItem.status === "s13_old_over",
            'status-other': this.listItem.status === "s14_other_channels"
        }
    }
}
